import { Fragment } from 'react';
import Card from '../ui/Card';
import Closebutton from '../ui/Closebutton';
import Item from '../ui/Item';
import milkshake from '../../img/milkshake.jpeg';
import penutbutter from '../../img/penutbutter.jpeg';
import chocshake from '../../img/chocshake.jpeg';
import strawberryshake from '../../img/strawberryshake.jpeg';
import bananna from '../../img/bananna.jpeg';
import caramell from '../../img/caramell.jpeg';
const dummy_data = [
    {
        key:'s1',
        name:'Milk Shakes',
        price:37000,
        icon:milkshake,
        description:'Sm / X2',

    },
    {
        key:'s2',
        name:'Penaut Butter',
        price:42000,
        icon:penutbutter,
        description:'Sm / X2',
    },
    {
        key:'s3',
        name:'Chocolate',
        price:43000,
        icon:chocshake,
        description:'Sm / X2',
    },
    {
        key:'s4',
        name:'Strawberry',
        price:38000,
        icon:strawberryshake,
        description:'Sm / X2',
    },
    {
        key:'s5',
        name:'Bannana',
        price:45000,
        icon:bananna,
        description:'Sm / X2',
    },
    {
        key:'s6',
        name:'Caramell',
        price:43000,
        icon:caramell,
        description:'Sm / X2',
    },
 
   
] ;


const Shakes = (props) => {

    const drinksList = dummy_data.map((shake) => (
 
    <Item
      key={shake.id}
      name={shake.name}
      price={shake.price}
      icon={shake.icon}
      description={shake.description}
    />
  ));
   
  return (
<Fragment>
    <Closebutton onClick={props.onClick}/>
<Card>

{drinksList}

   </Card>
   </Fragment>
   )
}


export default Shakes;